import React from 'react';

export default function Logo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="Crush Marketing logo">
      <rect x="0" y="0" width="64" height="64" rx="12" fill="#130F28" />
      {/* Three parallelogram bars */}
      <g transform="translate(14, 14)">
        <polygon points="0,36 8,0 14,0 6,36" fill="#6B4BEF" />
        <polygon points="12,36 20,0 26,0 18,36" fill="#6B4BEF" fillOpacity="0.45" />
        <polygon points="24,36 32,0 38,0 30,36" fill="#10C98F" fillOpacity="0.85" />
      </g>
    </svg>
  );
}
